import { enableProdMode, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { GlobalErrorHandler } from './app/core/global-error-handler/global-error-handler.service';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { CoreModule } from './app/core/core.module';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { routes } from './app/app-routing.module';

registerLocaleData(localeFr);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    importProvidersFrom(CoreModule),
    { provide: LOCALE_ID, useValue: navigator.language || 'fr' },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
}).catch((err) => console.error(err));
